import BaseFeature from '../../foundation/base/base';

const classes = {
	collapsed: 'o-list-group--collapsed',
	open: 'o-list-group--open',
	item: 'o-list-group__item',
};

export default class ListGroup extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.body = window.features.dom.body;
		this.initDomCache();

		this.contentHeight = this.dom.content.offsetHeight;
		this.expanderColumn = this.el.querySelector('.o-list-group__item');
		this.resizeTimeout = null; // Used by the resize function to throttle resize event

		this.collapseContent();
		this.initEvents();
	}

	initEvents() {
		// Add resize event
		window.addEventListener('resize', () => {
			this.resizeThrottler();
		});

		this.addEventListener(this.dom.toggle, 'click', (e) => {
			e.preventDefault();
			this.expandContent();
		});
	}

	resizeThrottler() {
		// Ignore resize events as long as an actualResizeHandler execution is in the queue
		if (!this.resizeTimeout) {
			this.resizeTimeout = setTimeout(() => {
				this.resizeTimeout = null;
				this.actualResizeHandler();
				// The actualResizeHandler will execute at a rate of 15fps
			}, 66);
		}
	}

	actualResizeHandler() {
		if (!this.el.classList.contains(classes.open)) {
			this.collapseContent();
		}
	}

	collapseContent() {
		if (this.el.classList.contains(classes.open)) return;
		// In some rare occations, 2x the height results in floating points.
		// It's enough to check for 1.5x the height since it should never be more than 1.
		if (this.dom.contentInner.offsetHeight >= (this.expanderColumn.offsetHeight * 1.5)) {
			// Multiply offset height with the percentage that should be visible.
			this.dom.content.style.maxHeight = (this.expanderColumn.offsetHeight * 1.25) + 'px';
			if (!this.el.classList.contains(classes.collapsed)) {
				this.el.classList.add(classes.collapsed);
			}
		} else if (this.el.classList.contains(classes.collapsed)) {
			this.el.classList.remove(classes.collapsed);
		}
	}

	expandContent() {
		this.dom.content.style.maxHeight = this.dom.contentInner.offsetHeight + 'px';
		if (!this.el.classList.contains(classes.open)) {
			setTimeout(() => {
				this.el.classList.add(classes.open);
				this.dom.content.style.maxHeight = 'none';
			}, 400);
		}
	}
}
